module.exports = __webpack_public_path__ + "img/app-five-full-star.e709c98c.svg";